import * as types from 'legacy/src/constants/types';

export function setNavData(data) {
  return (dispatch) => {
    dispatch({
      type: types.NAV_DATA,
      data,
    });
  };
}

export function setNavLoading(loading) {
  return (dispatch) => {
    dispatch({
      type: types.NAV_LOADING,
      loading,
    });
  };
}
